export default __webpack_public_path__ + "static/media/fav-icon.3d409d05.svg";